import script from "./MainDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./MainDashboard.vue?vue&type=script&setup=true&lang=js"

import "./MainDashboard.vue?vue&type=style&index=0&id=1f4b09fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f4b09fa"]])

export default __exports__